import Wrapper from './wrapPageElement';

export const wrapPageElement = Wrapper;
